import { Instance } from 'mobx-state-tree';
import { RouteTimelineEtaDtoModelBase } from './RouteTimelineEtaDtoModel.base';

/* The TypeScript type of an instance of RouteTimelineEtaDtoModel */
export interface RouteTimelineEtaDtoModelType extends Instance<typeof RouteTimelineEtaDtoModel.Type> {}

/* A graphql query fragment builders for RouteTimelineEtaDtoModel */
export { selectFromRouteTimelineEtaDto, routeTimelineEtaDtoModelPrimitives, RouteTimelineEtaDtoModelSelector } from './RouteTimelineEtaDtoModel.base';

/**
 * RouteTimelineEtaDtoModel
 */
export const RouteTimelineEtaDtoModel = RouteTimelineEtaDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
